// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"BackgroundModal_modal_wrapper__E7x++","modal_title":"BackgroundModal_modal_title__mcN10","modal_text":"BackgroundModal_modal_text__GX0iY"};